module.exports = __webpack_public_path__ + "img/commercial-xray-v2.dcfea655.png";